import React, { useEffect, useMemo, useState } from "react";
import { Button, Container, Form, Icon, Modal, Segment, Tab, Table, TabProps } from "semantic-ui-react";
import { AuthenticationState } from "../../../model/state/authentication-state";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { UserInfoResponse } from "../../../model/dto/response";
import { RetraitFondsModal } from "./retrait-fonds-modal"
import { InvestissementsPane } from "./tab/investissements-pane"
import { EcheancesPane } from "./tab/echeances-pane"
import { RetraitPane } from "./tab/retrait-pane"
import { RemboursementPane } from "./tab/remboursement-pane"
import { Profil } from "../../../model/entities/profil";
import { userService } from "../../../services/authentication-redux-service";

type Props = {
  loginProps?: AuthenticationState;
};

function DashboardCitoyen({ loginProps }: Props) {
  const [isEdited, setIsEdited] = useState(false)
  const [index, setIndex] = useState<number>(0);
  const [userInfo, setUserInfo] = useState<UserInfoResponse>()
  const [openPopUp, setOpenPopUp] = useState(false);
  const [openPopUpRetrait, setOpenPopUpRetrait] = useState(false);

  useEffect(() => {
      userService.getUserInfo(loginProps?.oauth?.userId, loginProps?.oauth)
      .then((response: UserInfoResponse) => {
        if(response.IsTraitementOk){
          setUserInfo(response)
        }
      })
  }, []);

  const valueWallet = useMemo(() => {
    if(userInfo?.MontantWalletNaturalUser) {
      return userInfo?.MontantWalletNaturalUser / 100
    }
    else if(userInfo?.Etablissement?.MontantWalletEtablissement) {
      return userInfo?.Etablissement?.MontantWalletEtablissement / 100
    }
    else {
      return 0
    }
  }, [userInfo])

  const handleRetourRemboursement= ()=>{
    setIndex(3);
    setOpenPopUp(true);
  }

  const handleRetraitFonds= ()=>{
    setIsEdited(false)
    setOpenPopUpRetrait(true);
  }

  const panes = [
    {
      menuItem: 'Mes investissements',
      render: () => {
          return (
              <Tab.Pane attached={false} 
                        css={{
                            background: 'transparent !important',
                            border: 'none !important'
                        }}
              >
                <InvestissementsPane handleRetourRemboursement={handleRetourRemboursement}/>
              </Tab.Pane>
          )
      },
    },
    {
      menuItem: 'Mes échéances',
      render: () => {
          return (
              <Tab.Pane attached={false} 
                        css={{
                            background: 'transparent !important',
                            border: 'none !important'
                        }}
              >
                <EcheancesPane />
              </Tab.Pane>
          )
      },
    },
    {
      menuItem: 'Mes retraits',
      render: () => {
          return (
              <Tab.Pane attached={false} 
                        css={{
                            background: 'transparent !important',
                            border: 'none !important'
                        }}
              >
                <RetraitPane />
              </Tab.Pane>
          )
      },
    },
    {
      menuItem: 'Mes remboursements',
      render: () => {
          return (
              <Tab.Pane attached={false} 
                        css={{
                            background: '#ECF0F1 !important',
                            border: 'none !important'
                        }}
              >
                <RemboursementPane />
              </Tab.Pane>
          )
      },
    }
  ]

  return (
    <div>
      <div>
        <Container>
          {loginProps?.oauth?.profilCode === Profil.INVESTISSEUR && openPopUp && 
            <Segment 
              css={{
                marginTop:"20px !important",
                border:"2px solid #BED3AF !important", 
                backgroundColor:"#E0F3D4 !important", 
                display:"flex", 
                flexDirection:"row", 
                alignItems:"center"
            }}>
                <div css={{
                      position: "absolute", 
                      right:"5px", 
                      top:"5px", 
                      cursor:"pointer"
                      }} 
                      onClick={()=>setOpenPopUp(false)}
                >
                    <Icon name="times" 
                          css={{
                            color:"#B0C6A3", 
                            "&:hover": {color: "#71797E"}
                          }} 
                          size="large">
                    </Icon>
                </div>
                <div css={{
                      flexBasis: "10%", 
                      alignSelf:"flex-start"
                     }}
                >
                    <Icon name="check" css={{color:"#5D7150"}} size="huge"/>
                </div>
                <div css={{flexBasis: "90%"}}>
                    <p 
                      css={{
                        color:"#5D7150", 
                        fontSize:"16px", 
                        fontWeight:"bold"}}
                    >
                    Votre demande de remboursement a bien été prise en compte. 
                    Vous pouvez suivre son avancement depuis votre tableau de bord sur l'onglet "Mes remboursements".
                    </p>
                </div>
            </Segment>
          }
          
          {loginProps?.oauth?.profilCode === Profil.INVESTISSEUR  && openPopUpRetrait &&
            <Segment 
              css={{
                position:"relative", 
                marginTop:"30px !important",
                backgroundColor:"#D1E9F7 !important",
                border: "solid 1px #005879 !important", 
                color: "#005879 !important", 
                padding: "26px 10px !important",  
                display:"flex", 
                flexDirection:"row", 
                alignItems:"center"
              }}
            >
              <div 
                css={{
                  position: "absolute", 
                  right:"5px", 
                  top:"5px", 
                  cursor:"pointer"
                }} 
                onClick={()=>setOpenPopUpRetrait(false)}
              >
                <Icon name="times" css={{color:"#005879", "&:hover": {color: "#327993"}}} size="large"></Icon>
              </div>

              <div css={{flexBasis: "4%", alignSelf:"center"}}>
                <Icon name='info circle' size='huge' css={{color:"#005879"}}/>
              </div>
              
              <div css={{flexBasis: "96%"}}>
                <p 
                  css={{
                    color:"#005879", 
                    fontSize:"18px", 
                    fontWeight:"bold",
                    marginLeft: "10px"
                  }}
                >
                  Votre opération est en cours de traitement, vous recevrez vos fonds dans quelques jours. Vous pouvez suivre l'avancement du transfert sur votre tableau de bord dans votre onglet "Mes retraits".
                </p>
              </div>
            </Segment>
          }
          
          <h1 className="py-8 text-3xl">Mon tableau de bord</h1>
          <div className="flex justify-center items-center">
            <div className="flex flex-col px-4 text-center text-xl text-gray-400">
              <span className="font-bold text-3xl">{valueWallet}€</span>
              <span >
                <Icon name="money" size="big" />
                {"   "}Somme disponible
              </span>
            </div>
            <div className="flex flex-col px-4">
              <div>
                <Button fluid primary onClick={() => setIsEdited(true)}>
                  <Icon name="minus circle" />
                  Retirer des fonds
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="pt-8">
        <Container>
          <Tab menu={{ secondary: true, pointing: true }} 
               panes={panes} 
               onTabChange={(e: any)=>setIndex(e.target.value)}
               activeIndex={index}
          />
        </Container>

        <Modal  onClose={() => setIsEdited(false)} open={isEdited}>
          <Modal.Header>Retirer des fonds</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <RetraitFondsModal 
                walletValue={valueWallet}
                onSubmitSuccess={() => setIsEdited(false)}
                handleRetraitFonds={handleRetraitFonds}
              />
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = (state: ApplicationState) => ({
  loginProps: state.authentication,
});

const ConnectedDashboardCitoyen = connect(
  mapStateToProps,
  null
)(DashboardCitoyen);
export { ConnectedDashboardCitoyen as DashboardCitoyen };
